// tslint:disable:no-bitwise
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OnInit, Renderer2, ElementRef, ChangeDetectorRef, OnDestroy, AfterViewInit } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { LabelModel } from 'src/app/story/models/labels/label.model';
import { filter, takeUntil, map, distinctUntilChanged } from 'rxjs/operators';
import { EngineState } from 'src/app/engine/state/engine.state';
import { EngineService } from 'src/app/engine/engine.service';
import { SelectLabel, SetLabel } from 'src/app/story/state/labels/story.labels.actions';
import { Observable, Subject, Subscription } from 'rxjs';
import * as Hammer from 'hammerjs';
import { CameraService } from 'src/app/engine/camera.service';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { SetCamera, SetZoomed } from 'src/app/engine/state/camera/engine.camera.actions';
import { EngineCameraState } from 'src/app/engine/state/camera/engine.camera.state';
import { LabelPinType } from 'src/app/story/models/labels/label-pin-type.enum';
import { LabelThemeEnum } from 'src/app/story/models/labels/label-theme.enum';
import { ErrandType } from 'src/app/story/models/errands/errand-type.enum';
import { get, isEqual } from 'lodash';
import { EventsEnum } from 'src/app/engine/models/events.enum';
import { LabelsService } from 'src/app/story/labels.service';
import { FlyToObject } from 'src/app/engine/state/engine.actions';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ColorUtils } from 'src/app/shared/libraries/colors/colors';
import { LabelCollapseModeEnum } from 'src/app/story/models/labels/label-collapse-mode';
var fullOpacity = 1;
var fadeStartAngle = 80;
var maxViewAngle = 100;
var fadeRange = maxViewAngle - fadeStartAngle;
// Hardcoded reference number. The actual pin width is set in label.component.scss.
var pinDiameter = 32;
var pinRadius = pinDiameter / 2;
var LabelStyleClass;
(function (LabelStyleClass) {
    LabelStyleClass["fadeIn"] = "label--fade-in";
    LabelStyleClass["fadeOut"] = "label--fade-out";
    LabelStyleClass["tagLeft"] = "label__tag--left";
    LabelStyleClass["tagRight"] = "label__tag--right";
})(LabelStyleClass || (LabelStyleClass = {}));
var LabelComponent = /** @class */ (function () {
    function LabelComponent(renderer, labelsService, engineService, cameraService, store, changeDetection) {
        this.renderer = renderer;
        this.labelsService = labelsService;
        this.engineService = engineService;
        this.cameraService = cameraService;
        this.store = store;
        this.changeDetection = changeDetection;
        this.labelPinType = LabelPinType;
        this.collapsed = false;
        this.collapsedMode = LabelCollapseModeEnum.None;
        this.theme = 'classic';
        this.pinDraggable = true;
        this.tagDraggable = true;
        // Cache position for performance
        this.enginePosition = null;
        this.isSelected = false;
        // Some labels change styles on dark background
        this.isBackgroundDark = false;
        // Local expanded / collapsed references
        this.descriptionCollapsed = false;
        this.tagCollapsed = false;
        // Pin
        this.pinDragging = false;
        // Reference to hammer event managers so we can unbind on destroy
        this.hammerManagers = [];
        this.displayUpdated$ = new Subject();
        this.positionUpdated$ = new Subject();
        this.ngUnsubscribe = new Subject();
    }
    Object.defineProperty(LabelComponent.prototype, "label", {
        get: function () {
            return this._label;
        },
        set: function (value) {
            var isValueNull = Object.keys(value).length === 0;
            var isLabelNull = this.label == null || Object.keys(this.label).length === 0;
            if (isValueNull && !isLabelNull) {
                this._label = value;
                this.destroyLabel();
            }
            else if (!isValueNull) {
                this._label = value;
                this.initLabel(this.label);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LabelComponent.prototype, "isCollapsed", {
        get: function () {
            if (this.collapsedMode === LabelCollapseModeEnum.Toggle) {
                return this.collapsed && !this.isSelected;
            }
            else {
                return this.collapsed;
            }
        },
        enumerable: true,
        configurable: true
    });
    LabelComponent.prototype.ngOnInit = function () {
        this.initListeners();
    };
    LabelComponent.prototype.ngAfterViewInit = function () {
        // We're using HammerJS to handle drag events for better touch compatibility. However
        // this results in Hammer 'tap' events preceeding Angular 'click' events, which can
        // lead to duplicate or unexpected click handling. So for labels, all interaction events are 
        // now handled through HammerJS, and initialized below. 
        this.bindTagEvents();
        this.bindPinEvents();
        this.bindHoverEvents();
    };
    LabelComponent.prototype.ngOnDestroy = function () {
        this.destroyLabel();
        this.emitDisplayUpdated({
            id: this.label.id,
            inView: false,
            shown: false,
            objectShown: this.objectShown
        });
        // Unsubscribe
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    LabelComponent.prototype.destroyLabel = function () {
        // Destroy event handlers bound outside of angular
        this.hammerManagers.forEach(function (manager) { return manager.destroy; });
        this.hammerManagers = [];
        // Delete markers in the engine
        this.deleteMarker(this.marker);
    };
    LabelComponent.prototype.initListeners = function () {
        var _this = this;
        // Handle selected label
        this.selectedLabel$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (label) { return _this.handleLabelSelected(label); });
        // Cache local copy of engine position any time it updates, for performance
        this.enginePosition$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (position) {
            _this.enginePosition = position;
        });
        // An exception of allowing another component to subscribe directly to engine events. 
        // Since marker position changes with any motion from the engine, running events through 
        // the store would create an unneccessary performance overhead. 
        this.engineService.getEvent(EventsEnum.SceneMarkersUpdated)
            .pipe(filter(function () {
            return _this.label != null && _this.enginePosition != null;
        }), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.setCanvasPos();
        });
        // notify display updates
        this.displayUpdated$
            .pipe(
        // detect change
        distinctUntilChanged(function (last, current) { return isEqual(last, current); }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (event) {
            _this.engineService.fireEvent(EventsEnum.HotspotsDisplayUpdated, event);
        });
        // notify position updates
        this.positionUpdated$
            .pipe(
        // detect change
        distinctUntilChanged(function (last, current) { return isEqual(last, current); }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (positionUpdate) {
            _this.engineService.fireEvent(EventsEnum.HotspotsPositionUpdated, positionUpdate);
        });
        // Observe background color, ensure appropriate color contrast is applied
        this.background$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (background) {
            var outerRGB = background.colors.slice(0, 3);
            var innerRGB = background.colors.slice(4, 7);
            _this.isBackgroundDark = !ColorUtils.isLight(outerRGB, innerRGB);
            _this.changeDetection.markForCheck();
        });
    };
    LabelComponent.prototype.bindTagEvents = function () {
        var _this = this;
        // Create a HammerJS manager so we can custom define single and double click
        var mc = new Hammer(this.tagRef.nativeElement, { domEvents: true });
        mc.get('pan').set({ direction: Hammer.DIRECTION_ALL, threshold: 3 });
        mc.on('pan', function (event) {
            if (!_this.tagDraggable) {
                return;
            }
            event.srcEvent.stopPropagation();
            if (!_this.cachedTagOffset) {
                _this.cachedTagOffset = _this.label.offset;
            }
            var offset = [
                _this.cachedTagOffset[0] + event.deltaX,
                _this.cachedTagOffset[1] + event.deltaY
            ];
            _this.label.offset = offset;
            if (event.isFinal) {
                _this.cachedTagOffset = null;
                _this.store.dispatch(new SetLabel(_this.label));
            }
        });
        mc.on('tap', function (event) {
            event.srcEvent.preventDefault();
            event.srcEvent.stopPropagation();
            // Hack to make expand button work differently from rest of tag.
            // Normally wouldn't have to do this, but HammerJS creates very strange
            // event handling loops. 
            if (event.target.parentNode.nodeName === 'BUTTON') {
                _this.toggleDescription();
                // this.changeDetection.markForCheck();
            }
            else {
                _this.selectLabel();
            }
        });
        this.hammerManagers.push(mc);
    };
    LabelComponent.prototype.bindPinEvents = function () {
        var _this = this;
        // Create a HammerJS manager so we can custom define single and double click
        var mc = new Hammer(this.pinRef.nativeElement);
        mc.get('pan').set({ direction: Hammer.DIRECTION_ALL, threshold: 4 });
        mc.on('pan', function (event) {
            if (!_this.pinDraggable) {
                return;
            }
            event.srcEvent.stopPropagation();
            // While pinDragging is true, setCanvasPos won't fire, which allows us to 
            // change the pin X and Y translation without interference from the engine.
            _this.pinDragging = true;
            var _a = event.changedPointers[0], layerX = _a.layerX, layerY = _a.layerY;
            layerX = layerX - pinRadius;
            layerY = layerY - pinRadius;
            // Marker is updated by the engine every tick, so we have to kill it or else the engine
            // will overwrite our changes. 
            if (_this.marker) {
                _this.deleteMarker(_this.marker);
            }
            // Manually update the pin position to the mouse cursor position
            _this.renderer.setStyle(_this.labelContainerRef.nativeElement, 'transform', "translate(" + layerX + "px, " + layerY + "px)");
            if (event.isFinal) {
                _this.pinDragging = false;
                var label = __assign({}, _this.label);
                // If the pin is dropped on a node, update the position. Otherwise just revert the pin back to 
                // it's original location.
                var hit = Human.renderer.pick.pick({ canvasPos: [layerX, layerY], rayPick: true });
                if (hit.objectId) {
                    label.dir = _this.cameraService.getDirection(hit);
                    label.objectId = hit.objectId;
                    label.barycentric = [hit.barycentric[0], hit.barycentric[1], hit.barycentric[2]];
                    label.pos = [hit.worldPos[0], hit.worldPos[1], hit.worldPos[2]];
                    label.primitiveIndex = hit.primitiveIndex;
                }
                _this.store.dispatch(new SetLabel(label));
            }
        });
        mc.on('tap', function (event) {
            event.srcEvent.preventDefault();
            event.srcEvent.stopImmediatePropagation();
            _this.selectLabel();
        });
        this.hammerManagers.push(mc);
    };
    LabelComponent.prototype.bindHoverEvents = function () {
        var _this = this;
        var label = this.labelRef.nativeElement;
        this.renderer.listen(label, 'mouseenter', function () {
            _this.engineService.fireEvent(EventsEnum.HotspotsEntered, { id: _this.label.id });
        });
        this.renderer.listen(label, 'mouseleave', function () {
            _this.engineService.fireEvent(EventsEnum.HotspotsLeft, { id: _this.label.id });
        });
    };
    LabelComponent.prototype.initLabel = function (label) {
        this.initMarker(label);
        this.ensureObjectId(label);
        this.initObjectSubscription(label);
        this.descriptionCollapsed = label.collapseDescription;
        this.tagCollapsed = label.hideTag;
    };
    LabelComponent.prototype.initMarker = function (label) {
        if (this.marker) {
            this.deleteMarker(this.marker);
        }
        this.marker = Human.scene.markers.create({
            // track marker by label id
            id: label.id,
            pos: label.pos,
            dir: label.dir,
            objectId: label.objectId,
            primitiveIndex: label.primitiveIndex,
            barycentric: label.barycentric,
            renderableIndex: label.renderableIndex || 0
        });
    };
    LabelComponent.prototype.checkLabelDisplay = function () {
        return {
            id: this.label.id,
            shown: this.label.shown,
            inView: this.isOnCanvas(),
            objectShown: true
        };
    };
    // labels should always have an objectId
    LabelComponent.prototype.ensureObjectId = function (label) {
        if (!label.objectId) {
            var hit_1 = Human.renderer.pick.pick({ canvasPos: [this.marker.canvasPos[0], this.marker.canvasPos[1]], rayPick: true });
            // attach to object: if hit
            if (hit_1.objectId) {
                label.objectId = hit_1.objectId;
                label.states.forEach(function (labelState) {
                    labelState.errands.forEach(function (errand) {
                        if (errand.type === ErrandType.flyToObject) {
                            errand.value = hit_1.objectId;
                        }
                    });
                });
                this.store.dispatch(new SetLabel(label));
            }
        }
    };
    LabelComponent.prototype.initObjectSubscription = function (label) {
        var _this = this;
        if (this.object$) {
            this.object$.unsubscribe();
        }
        // Listen to attached node and check for visibility Don't show labels with
        // hidden nodes 
        if (label.objectId) {
            this.object$ = this.store.select(EngineState.getViewGraphNode)
                .pipe(map(function (filterFn) { return filterFn(label.objectId); }), filter(function (node) { return !!node; }), takeUntil(this.ngUnsubscribe))
                .subscribe(function (node) {
                _this.objectShown = node.boolState.shown;
            });
        }
    };
    LabelComponent.prototype.deleteMarker = function (marker) {
        Human.scene.markers.delete(marker.id);
        this.marker = null;
    };
    LabelComponent.prototype.toggleDescription = function (open) {
        open = (typeof open === 'undefined') ? !this.descriptionCollapsed : open;
        this.descriptionCollapsed = open;
    };
    LabelComponent.prototype.handleLabelSelected = function (label) {
        var _this = this;
        this.isSelected = (label && label.id === this.label.id);
        var errands = get(label, 'states[1].errands');
        var cameraLocked = this.store.selectSnapshot(EngineCameraState.getLockCamera);
        // Fly to
        if (this.isSelected && errands && !cameraLocked) {
            errands.forEach(function (errand) {
                switch (errand.type) {
                    case ErrandType.flyToObject:
                        _this.flyToObject(errand.value);
                        break;
                    case ErrandType.flyToCamera:
                        _this.flyToPosition(errand.value);
                        break;
                }
                _this.store.dispatch(new SetZoomed(true));
            });
        }
        // Expand
        var tagEnabled = !!this.label.title || !!this.label.description;
        if (!tagEnabled) {
            this.tagCollapsed = true;
        }
        else if (this.label.expandTag && this.label.hideTag) {
            this.tagCollapsed = !this.isSelected;
        }
        else {
            this.tagCollapsed = this.label.hideTag;
        }
        // Show description
        if (this.label.showDescription && this.label.collapseDescription) {
            this.descriptionCollapsed = !this.isSelected;
        }
        else {
            this.descriptionCollapsed = this.label.collapseDescription;
        }
    };
    LabelComponent.prototype.flyToObject = function (objectId) {
        this.store.dispatch(new FlyToObject(objectId));
    };
    LabelComponent.prototype.flyToPosition = function (cameraPosition) {
        this.store.dispatch(new SetCamera(cameraPosition));
    };
    LabelComponent.prototype.setCanvasPos = function () {
        if (this.pinDragging || !this.marker) {
            return;
        }
        this.depth = -this.marker.viewPos[2];
        // The position can update the display state via the shown property
        // Only call if shown has changed
        var isOccluded = this.isOccluded();
        var isOnCanvas = this.isOnCanvas();
        // if the label isn't attached to an object Id, 
        // `this.objectShown` will always be undefined.
        // Therefore, it should only be queried if we're sure that the label is attached to an object.
        var shown = this.label.objectId === undefined
            ? !isOccluded && isOnCanvas
            : !isOccluded && isOnCanvas && this.objectShown;
        if (shown !== this.shown) {
            this.shown = shown;
            this.setDisplay(true);
        }
        // this.setOpacity();
        this.setElementPosition();
        this.setTagPosition();
        this.setWirePosition();
        // publish position updates
        var _a = this.marker.canvasPos, x = _a[0], y = _a[1];
        this.positionUpdated$.next({
            id: this.label.id,
            canvasPos: { x: x, y: y }
        });
    };
    LabelComponent.prototype.selectLabel = function () {
        var previousLabel = this.store.selectSnapshot(StoryLabelsState.getSelectedLabel);
        // Clicking same label to unselect
        if (previousLabel && previousLabel.id === this.label.id) {
            this.store.dispatch(new SelectLabel(null));
        }
        else {
            this.store.dispatch(new SelectLabel(this.label));
        }
        this.engineService.fireEvent(EventsEnum.HotspotsPicked, { id: this.label.id });
    };
    LabelComponent.prototype.isOccluded = function () {
        return (!this.isSelected && // Selected labels should always show
            this.label.occludable &&
            (Math.abs(this.marker.viewAngle) > maxViewAngle ||
                this.marker.occluded ||
                this.depth < 0));
    };
    LabelComponent.prototype.isOnCanvas = function () {
        var _a = this.labelsService.getLabelContainer().nativeElement, offsetWidth = _a.offsetWidth, offsetHeight = _a.offsetHeight;
        var _b = __read(this.marker.canvasPos, 2), x = _b[0], y = _b[1];
        var onCanvas = x > 0 && y > 0 && x < offsetWidth && y < offsetHeight;
        return onCanvas;
    };
    /**
     * Show and hide labels
     */
    LabelComponent.prototype.setDisplay = function (transition) {
        var labelEl = this.labelRef.nativeElement;
        // Remove any previous transition classes
        this.renderer.removeClass(labelEl, LabelStyleClass.fadeIn);
        this.renderer.removeClass(labelEl, LabelStyleClass.fadeOut);
        if (transition) {
            var cssClass = (this.shown) ? LabelStyleClass.fadeIn : LabelStyleClass.fadeOut;
            this.renderer.addClass(labelEl, cssClass);
            this.renderer.setStyle(labelEl, 'visibility', 'visible');
        }
        else {
            var display = (this.shown) ? 'visible' : 'hidden';
            this.renderer.setStyle(labelEl, 'visibility', display);
        }
        // This is created for the EventsEnum.HotspotsDisplayUpdated event
        this.emitDisplayUpdated({
            id: this.label.id,
            inView: this.isOnCanvas(),
            shown: this.shown,
            objectShown: this.objectShown
        });
    };
    LabelComponent.prototype.setOpacity = function () {
        var opacity = fullOpacity;
        if (this.marker.viewAngle >= fadeStartAngle) {
            var angleDiff = this.marker.viewAngle - fadeStartAngle;
            var scaledOpacity = (angleDiff / fadeRange) * fullOpacity;
            opacity = Math.max(1 - scaledOpacity, 0);
        }
        this.renderer.setStyle(this.labelContainerRef.nativeElement, 'opacity', opacity);
    };
    LabelComponent.prototype.setElementPosition = function () {
        var markerPos = this.marker.canvasPos;
        this.renderer.setStyle(this.labelContainerRef.nativeElement, 'transform', "translate(" + markerPos[0] + "px, " + markerPos[1] + "px)");
    };
    LabelComponent.prototype.setTagPosition = function () {
        var offset = this.label.offset;
        var tagWidth = this.tagRef.nativeElement.offsetWidth;
        var side = (this.label.offset[0] > 0) ? 'left' : 'right';
        switch (side) {
            case 'left':
                this.renderer.setStyle(this.tagRef.nativeElement, 'transform', "translate(" + (16 + offset[0]) + "px, " + offset[1] + "px)");
                break;
            case 'right':
                this.renderer.setStyle(this.tagRef.nativeElement, 'transform', "translate(" + (16 + offset[0] - tagWidth) + "px, " + offset[1] + "px)");
                break;
        }
    };
    LabelComponent.prototype.setWirePosition = function () {
        // tslint:disable-next-line:prefer-const
        var _a = __read(this.label.offset, 2), x = _a[0], y = _a[1];
        // For annotation and hotspot, move line down to below title
        switch (this.label.theme) {
            case LabelThemeEnum.Annotation:
            case LabelThemeEnum.Classic:
                var height = this.titleRef.nativeElement.offsetHeight - 16 - 2; // 16px is half of pin, 2 is border
                y += height;
                break;
        }
        var wireLength = Math.sqrt(x * x + y * y);
        this.renderer.setStyle(this.wireRef.nativeElement, 'width', wireLength + "px");
        this.renderer.setStyle(this.wireRef.nativeElement, 'transform', "rotate(" + Math.atan2(y, x) + "rad)");
    };
    LabelComponent.prototype.emitDisplayUpdated = function (event) {
        // Never emit context-label events
        if (this.label.id === 'context-label') {
            return;
        }
        // Don't emit events that lack details
        if (event.inView == null || event.shown == null || event.objectShown == null) {
            return;
        }
        this.displayUpdated$.next(event);
    };
    __decorate([
        Select(EngineState.getEnginePosition),
        __metadata("design:type", Observable)
    ], LabelComponent.prototype, "enginePosition$", void 0);
    __decorate([
        Select(StoryLabelsState.getSelectedLabel),
        __metadata("design:type", Observable)
    ], LabelComponent.prototype, "selectedLabel$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterBackground),
        __metadata("design:type", Observable)
    ], LabelComponent.prototype, "background$", void 0);
    return LabelComponent;
}());
export { LabelComponent };
